const time={ms:seconds=>1e3*seconds,s:milliseconds=>milliseconds/1e3};export{time};